var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn menu-toggle-btn",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.toggleMenu($event)}}},[_c('i',{staticClass:"fa fa-bars",attrs:{"id":"menuToggle","aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }